// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

import "../styles/index.scss"

const application = Application.start()
const context = require.context("./../controllers/application", false, /\.(js|ts)x?$/)
const sharedContext = require.context("./../controllers/shared", false, /\.(js|ts)x?$/)

application.load(definitionsFromContext(context))
application.load(definitionsFromContext(sharedContext))

document.addEventListener("turbo:visit", function () {
  if (window.posthog) {
    window.posthog.capture("$pageview")
  }
})

// When a form submission happens with a turbo-frame target of "_top" only accept the HTML response
// This means that forms opened in a new window will redirect instead of trying to update turbo streams
document.addEventListener("turbo:submit-start", event => {
  const parentFrame = event.target.closest("turbo-frame")

  if (parentFrame && parentFrame.getAttribute("target") === "_top") {
    event.detail.formSubmission.fetchRequest.fetchOptions.headers["Accept"] =
      "text/html, application/xhtml+xml"
  }
})

// Strip any `<noscript>` elements just before the page changes
document.addEventListener("turbo:before-render", event => {
  for (const noscript of event.detail.newBody.querySelectorAll("noscript")) {
    noscript.remove()
  }
})
